import type {
  Maybe,
  listingOwnershipPeriod_bool_exp,
} from '@vrplatform/graphql';

export const whereListingPeriod = ({
  listingId,
  ownerIds,
  date,
  type,
}: {
  type: 'ownership' | 'disabled' | 'both';
  listingId?: Maybe<string>;
  ownerIds?: Maybe<string[]>;
  date?: Maybe<string>;
}): listingOwnershipPeriod_bool_exp => {
  return {
    listingId: listingId ? { _eq: listingId } : undefined,
    members: ownerIds?.length ? { contactId: { _in: ownerIds } } : {}, // { contactId: { _is_null: false } }, // PRO-9694 - Ensure empty ownerships are shown in the UI (listings)
    setListingInactive:
      type === 'both' ? undefined : { _eq: type === 'disabled' },
    _or: date
      ? [
          {
            startAt: {
              _lte: date,
            },
            endAt: {
              _gte: date,
            },
          },
          {
            startAt: {
              _lte: date,
            },
            endAt: {
              _is_null: true,
            },
          },
        ]
      : undefined,
  };
};
